import { create } from 'zustand'

type CreateConversationStatus
  = | 'idle'
    | 'creating_conversation'
    | 'create_conversation_error'

type CreateConversationStatusState = {
  status: CreateConversationStatus
  setStatus: (conversationStatus: CreateConversationStatus) => void
}

const initialState: Pick<CreateConversationStatusState, 'status'> = {
  status: 'idle',
}

const useCreateConversationStatusStore
  = create<CreateConversationStatusState>(set => ({
    ...initialState,
    setStatus: (status: CreateConversationStatus) => set({ status }),
  }))

export const useCreateConversationStatus = () =>
  useCreateConversationStatusStore(state => state.status)

export const useSetCreateConversationStatus = () =>
  useCreateConversationStatusStore(state => state.setStatus)
